import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HubHome from "./pages/HubHome";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import ComingSoon from "./pages/ComingSoon";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLogin from "./pages/admin/AdminLogin";
import RequireAdminAuth from "./pages/admin/RequireAdminAuth";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import { ClientAuthProvider } from "./contexts/ClientAuthContext";
import ClientLogin from "./pages/client/ClientLogin";
import ClientRegister from "./pages/client/ClientRegister";
import ClientDashboard from "./pages/client/ClientDashboard";
import ProjectDetail from "./pages/client/ProjectDetail";
import RequireClientAuth from "./pages/client/RequireClientAuth";
import StoreLayout from "./pages/store/StoreLayout";
import StoreLanding from "./pages/store/StoreLanding";
import StoreProductDetail from "./pages/store/ProductDetail";
import CheckoutPage from "./pages/store/CheckoutPage";
import AccountPage from "./pages/store/AccountPage";
import { StoreAuthProvider } from "./contexts/StoreAuthContext";
import { CartProvider } from "./contexts/CartContext";
import { ToastProvider } from "./components/Toast";
import ErrorBoundary from "./components/ErrorBoundary";
import StoreAccessToggle from "./components/store/StoreAccessToggle";

export default function App() {
    return (
        <ErrorBoundary>
            <ToastProvider>
                <AdminAuthProvider>
                    <ClientAuthProvider>
                        <StoreAuthProvider>
                            <CartProvider>
                                <BrowserRouter>
                                    <Routes>
                                        <Route path="/" element={<HubHome />} />
                                        <Route path="/legacy" element={<HomePage />} />
                                        <Route path="/admin/login" element={<AdminLogin />} />
                                        <Route
                                            path="/admin"
                                            element={
                                                <RequireAdminAuth>
                                                    <AdminDashboard />
                                                </RequireAdminAuth>
                                            }
                                        />
                                        <Route path="/client/login" element={<ClientLogin />} />
                                        <Route path="/client/register" element={<ClientRegister />} />
                                        <Route
                                            path="/client/dashboard"
                                            element={
                                                <RequireClientAuth>
                                                    <ClientDashboard />
                                                </RequireClientAuth>
                                            }
                                        />
                                        <Route
                                            path="/client/projects/:projectId"
                                            element={
                                                <RequireClientAuth>
                                                    <ProjectDetail />
                                                </RequireClientAuth>
                                            }
                                        />
                                        <Route path="/privacy" element={<PrivacyPolicy />} />

                                        {/* Coming Soon Pages */}
                                        <Route path="/portfolio" element={<ComingSoon />} />
                                        <Route path="/services" element={<ComingSoon />} />
                                        <Route path="/education" element={<ComingSoon />} />

                                        <Route element={<StoreLayout />}>
                                            <Route path="/store" element={<StoreLanding />} />
                                            <Route path="/store/product/:productId" element={<StoreProductDetail />} />
                                            <Route path="/checkout" element={<CheckoutPage />} />
                                            <Route path="/account" element={<AccountPage />} />
                                        </Route>

                                        <Route path="*" element={<NotFound />} />
                                    </Routes>
                                    <StoreAccessToggle />
                                </BrowserRouter>
                            </CartProvider>
                        </StoreAuthProvider>
                    </ClientAuthProvider>
                </AdminAuthProvider>
            </ToastProvider>
        </ErrorBoundary>
    );
}
